import CommoditiesTableTab from './CommoditiesTableTab';

import type { CommoditiesTableSectionType } from '../types';

const CommoditiesTable = ({
  layout,
  sections
}: {
  sections: CommoditiesTableSectionType[] | undefined;
  layout?: { fullWidth?: boolean; height?: number };
}) => {
  return (
    sections && (
      <CommoditiesTableTab
        height={layout?.height}
        sections={sections}
      />
    )
  );
};

export default CommoditiesTable;
